import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const projects = [{
  title: "BIM Structural Modeling",
  category: "ENGINEERING",
  description: "High-fidelity structural analysis and wireframe generation for complex commercial infrastructures and industrial hubs.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/bim_structural_wireframe.png",
  href: "/ProjectsPage"
}, {
  title: "Laboratory System Integration",
  category: "BIOTECH",
  description: "Advanced spatial planning for clinical laboratory environments featuring integrated HVAC and technical safety protocols.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/laboratory_tech_shot.png",
  href: "/ProjectsPage"
}, {
  title: "Digital Twin Implementation",
  category: "MANUFACTURING",
  description: "Real-time synchronization of physical manufacturing assets with high-fidelity digital replicas for predictive maintenance.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/digital_twin_model.png",
  href: "/ProjectsPage"
}, {
  title: "MEP Coordination Matrix",
  category: "CONSTRUCTION",
  description: "Automated clash detection and resolution for mechanical, electrical, and plumbing networks in high-rise developments.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/mep_coordination_view.png",
  href: "/ProjectsPage"
}, {
  title: "Grid Optimization Project",
  category: "INFRASTRUCTURE",
  description: "Optimizing regional power distribution through algorithmic load balancing and seamless renewable energy integration.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/infrastructure_grid_tech.png",
  href: "/ProjectsPage"
}, {
  title: "Advanced Materials Testing",
  category: "RESEARCH",
  description: "Technical characterization of high-performance alloys and composites for aerospace and defense applications.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/materials_lab_analysis.png",
  href: "/ProjectsPage"
}, {
  title: "Infrastructure Framework",
  category: "URBAN",
  description: "Developing the foundational data architecture for responsive urban mobility and centralized utility management systems.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/urban_framework_bim.png",
  href: "/ProjectsPage"
}, {
  title: "Fluid Dynamics Simulation",
  category: "UTILITIES",
  description: "Computational fluid dynamics modeling for municipal water treatment and high-pressure distribution networks.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/hydraulic_flow_simulation.png",
  href: "/ProjectsPage"
}];
export default function ProjectsOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="34927" id="project-showcase" ref={ref} className="bg-background text-foreground py-32 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`mb-16 max-w-3xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-default font-bold tracking-tight text-primary mb-6">
            Project Portfolio
          </h2>
          <p className="text-xl text-muted-foreground font-sans">
            Delivering technical excellence through precision engineering, BIM coordination, and advanced laboratory design solutions for global industry leaders.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-[cubic-bezier(0.25,0.1,0.25,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-20"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Link to={project.href} className="block h-full group">
                <Card className="h-full border border-border bg-card shadow-xl rounded-none overflow-hidden relative transition-all duration-500 ease-[cubic-bezier(0.25,0.1,0.25,1)] group-hover:border-primary/20">
                  <div className="relative h-48 w-full overflow-hidden border-b border-border">
                    <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                    <Badge variant="secondary" className="absolute top-4 right-4 font-mono text-xs tracking-wider border border-border bg-background text-primary rounded-none px-3 py-1 shadow-none z-10">
                      {project.category}
                    </Badge>
                  </div>

                  <CardHeader className="pt-8 pb-2">
                    <CardTitle className="font-default text-2xl font-bold text-primary group-hover:text-accent transition-colors">
                      {project.title}
                    </CardTitle>
                  </CardHeader>

                  <CardContent>
                    <p className="text-muted-foreground font-sans leading-relaxed">
                      {project.description}
                    </p>
                  </CardContent>

                  <CardFooter className="mt-auto pt-4 pb-8">
                    <Button variant="link" className="p-0 h-auto font-mono text-sm font-bold text-primary group-hover:text-accent transition-colors flex items-center">
                      VIEW SPECIFICATIONS <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </CardFooter>
                </Card>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}